import { Paragraph } from 'roo-ui/components';

const RequestReviewInfo = () => (
  <Paragraph fontSize="lg" mb={0}>
    Your new dates are available. Please review and confirm your stay below.
  </Paragraph>
);

export default RequestReviewInfo;
